import React, { useState } from 'react';
import { Mail, CheckCircle, AlertCircle } from 'lucide-react';
import { Button } from './ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const NewsletterSubscribeForm = ({ variant = 'default', className = '' }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!consent) {
      setStatus('error');
      setMessage('Bitte akzeptieren Sie die Datenschutzerklärung.');
      return;
    }

    setStatus('loading');
    
    try {
      const response = await axios.post(`${BACKEND_URL}/api/newsletter/subscribe`, {
        email,
        name: name || null,
        consent: true
      });
      
      setStatus('success');
      setMessage(response.data.message);
      setEmail('');
      setName('');
      setConsent(false);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Ein Fehler ist aufgetreten.');
    }
  };

  if (status === 'success') {
    return (
      <div className={`flex items-center gap-3 p-4 rounded-lg bg-green-900/20 border border-green-500/30 ${className}`}>
        <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0" />
        <div>
          <p className="text-sm font-medium text-green-400">Erfolgreich angemeldet!</p>
          <p className="text-xs text-gray-400 mt-1">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="space-y-3">
        <div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Ihre E-Mail-Adresse"
            required
            className="w-full px-4 py-2.5 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-blue-400"
          />
        </div>

        {variant === 'full' && (
          <div>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ihr Name (optional)"
              className="w-full px-4 py-2.5 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-blue-400"
            />
          </div>
        )}

        <div className="flex items-start gap-2">
          <input
            type="checkbox"
            id="newsletter-consent"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            className="mt-1 w-4 h-4 rounded border-gray-600 bg-white/5 text-blue-500"
          />
          <label htmlFor="newsletter-consent" className="text-xs text-gray-400">
            Ich stimme der <a href="/datenschutz" className="text-blue-400 hover:text-blue-300 underline">Datenschutzerklärung</a> zu.
          </label>
        </div>

        {status === 'error' && (
          <div className="flex items-center gap-2 p-3 rounded-lg bg-red-900/20 border border-red-500/30">
            <AlertCircle className="w-4 h-4 text-red-400" />
            <p className="text-xs text-red-400">{message}</p>
          </div>
        )}

        <Button
          type="submit"
          disabled={status === 'loading'}
          className="w-full bg-gradient-to-r from-blue-500 to-cyan-400 hover:from-blue-600 hover:to-cyan-500 text-white font-medium"
        >
          {status === 'loading' ? 'Wird verarbeitet...' : (
            <span className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              Newsletter abonnieren
            </span>
          )}
        </Button>
      </div>
    </form>
  );
};
